import { ga } from 'js/analytics/adapters'
export const trackSelectGender = ({ gender }) => {
  const props = {
    Gender: gender,
  }
  ga.track('Select Gender', props)
}
